export const tableContentType = {
    DATE_TIME: "DATE_TIME",
    TIME_AGO: "TIME_AGO",
    ID: "ID",
    LINK: "LINK",
    PRICE: "PRICE",
    PRODUCT: "PRODUCT",
    TITLE: "TITLE",
    TABLE_TITLE: "TABLE_TITLE",
    INDICATOR: "INDICATOR",
    TEXT: "TEXT",
    STATUS: "STATUS",
    COMPLAINT_STATUS: "COMPLAINT_STATUS",
    STICKER_STATUS: "STICKER_STATUS",
    COLLABORATOR_STATUS: "COLLABORATOR_STATUS",
    APP_NAME: "APP_NAME",
    ACTION: "ACTION",
    EMPTY: "EMPTY",
    POP_OVER: "POP_OVER",
    EMAIL: "EMAIL",
    SHIMMER: "SHIMMER",
    IMAGE: "IMAGE",
    PERCENTAGE: "PERCENTAGE",
    YES_NO: "YES_NO"
};